import request from '@/utils/request'

// 订单统计
export function getStatisticalOrder (params) {
  return request({
    url: '/mcht/statistical/order',
    method: 'get',
    params
  })
}

// 订单统计-订单列表
export function getStatisticalList (params) {
  return request({
    url: '/mcht/statistical/order/list',
    method: 'get',
    params
  })
}

// 销售统计
export function getStatisticalSales (params) {
  return request({
    url: '/mcht/statistical/sales',
    method: 'get',
    params
  })
}

// 销售明细及排行
export function getsalesDetails (params) {
  return request({
    url: '/mcht/statistical/salesSupplier/list',
    method: 'get',
    params
  })
}

// 新增商品统计
export function addStatistical (params) {
  return request({
    url: '/product/statistical/new/addStatistical',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/report.js